<template>
  <div>
    <h1>Dev Component</h1>
    <p>This is a development-only view for testing Vue components.</p>
    <router-view />
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class DevView extends Vue {}
</script>
